import { render, staticRenderFns } from "./StripeCardExpirationInput.vue?vue&type=template&id=5cf4d980&scoped=true&"
import script from "./StripeCardExpirationInput.vue?vue&type=script&lang=js&"
export * from "./StripeCardExpirationInput.vue?vue&type=script&lang=js&"
import style0 from "./StripeCardExpirationInput.vue?vue&type=style&index=0&id=5cf4d980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4d980",
  null
  
)

export default component.exports